import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box, MenuItem } from '@mui/material';
import { surgeryOptions, anesthesiaOptions } from '../constants/options';

const SurgeryDetailsSection = ({ formData, handleChange, setFormData, errors }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 6: Planned Surgery Details
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={surgeryOptions}
            value={formData.surgery_type || ''}
            onInputChange={(_, newVal) => setFormData(prev => ({ ...prev, surgery_type: newVal }))}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Surgery Type *"
                required
                fullWidth
                error={!!errors.surgery_type}
                helperText={errors.surgery_type}
              />
            )}
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            label="Planned Surgical Date"
            name="planned_surgical_date"
            type="date"
            fullWidth
            value={formData.planned_surgical_date || ''}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: new Date().toISOString().slice(0, 10) }}
            error={!!errors.planned_surgical_date}
            helperText={errors.planned_surgical_date}
          />
        </Grid>

        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={anesthesiaOptions}
            value={formData.planned_anesthesia_type || ''}
            onInputChange={(_, newVal) => setFormData(prev => ({ ...prev, planned_anesthesia_type: newVal }))}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Planned Anesthesia Type"
                fullWidth
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SurgeryDetailsSection;
